// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"725":"ff639ec0","773":"2072feaf","787":"47aff417"}[chunkId] + ".chunk.css";
};